var widget_default = {
  "card": "Ra-fJ",
  "link": "ypUlt",
  "container": "_81OwW",
  "image": "Q2knQ",
  "right": "DsuI8",
  "cardLayout": "_4Ue-e",
  "content": "_1pCNM",
  "title": "v7WrU",
  "subtitle": "xibvE",
  "button": "_95cSq",
  "button_disabled": "gxfuc",
  "buttonText": "fln0w",
  "slimLayout": "LeClT",
  "contentText": "FhLo1"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
